<style scoped>
.br-12 {
  border-radius: 12px;
}
</style>

<template>
  <div>
    <v-layout row wrap justify-center v-if="isLoading || services.length === 0">
      <v-flex xs12 sm6 md6 lg4 xl3 pa-1 v-for="i in 10" :key="i">
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="card"
        ></v-skeleton-loader>
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-center ma-3 v-if="!isLoading && services.length > 0 && newUI">
      <v-flex xs12 sm6 md6 lg4 xl3 pa-1 v-for="(service, i) in services" :key="i">
        <v-card @click.native="service.coming_soon ? '' : $router.push(service.route)">
          <div style="position: absolute; z-index: +1;" v-if="service.new">
            <img src="img/cards/new.png">
          </div>
          <div style="position: absolute; z-index: +1;" v-if="service.coming_soon">
            <img src="img/cards/coming-soon.png">
          </div>
          <v-img class="white--text" height="100%" :src="`img/cards/${service.image}`">
            <v-layout fill-height>
              <v-layout align-end d-flex>
                <div style="background-color: black; opacity: 0.65; width: 100%">
                  <span class="pa-3 d-flex xs12 headline">{{ $t(service.label) }}
                    <span class="pl-1" style="font-size: 16px; margin-top: 0px" v-if="service.label == 'mptgis' || service.internal">
                      ({{ $t('internal_use') }})
                    </span>
                  </span>
                </div>
              </v-layout>
            </v-layout>
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout text-center align-start justify-center row fill-height ma-3 v-if="!newUI">
      <v-layout row wrap pa-2 justify-center>
        <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="$router.push('assessment')">
            <v-img class="white--text" height="100%" src="img/cards/house.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">{{ $t('assessment_landcess') }}</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="$router.push('license')">
            <v-img class="white--text" height="100%" src="img/cards/license.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">{{ $t('council_permit_license') }}</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="$router.push('trading')">
            <v-img class="white--text" height="100%" src="img/cards/trading_application.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">{{ $t('trading_license') }}</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="$router.push('compound')">
            <v-img class="white--text" height="100%" src="img/cards/compounds.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">{{ $t('compound') }}</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="routes('mptweb')">
            <v-img class="white--text" height="100%" src="img/cards/mpt_menu.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">{{ $t('web_portal_mpt') }}</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="routes('mptpay')">
            <v-img class="white--text" height="100%" src="img/cards/9.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">MPTPAY</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="$router.push('complaint')">
            <v-img class="white--text" height="100%" src="img/cards/10.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">{{ $t('ecomplaint') }}</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="$router.push('feedback')">
            <v-img class="white--text" height="100%" src="img/cards/feedback.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">{{ $t('efeedback') }}</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="routes('chatbot')">
            <v-img class="white--text" height="100%" src="img/cards/customer_service.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">{{ $t('chatbot') }}</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <!-- <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="$router.push({ name: 'e-billing' })">
            <v-img class="white--text" height="100%" src="img/cards/feedback.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">e-Billing</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex> -->
        <!-- <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="$router.push('ticket')">
            <v-img class="white--text" height="100%" src="img/cards/customer_service.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">{{ $t('customerService') }}</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex> -->
        <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="routes('mptgis')">
            <v-img class="white--text" height="100%" src="img/cards/gis.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; text-align:left; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">MPTGIS <span class="pl-1" style="font-size: 16px; margin-top: 0px">({{ $t('internal_use') }})</span></span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6 lg4 xl3 pa-1>
          <v-card @click.native="$router.push('tutorial')">
            <v-img class="white--text" height="100%" src="img/cards/tutorial.png">
              <v-layout fill-height>
                <v-layout align-end d-flex>
                  <div style="background-color: black; opacity: 0.65; width: 100%">
                    <span class="pa-3 d-flex xs12 headline">{{ $t('tutorial') }}</span>
                  </div>
                </v-layout>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import axios from '../axios'
import configurations from './../configurations'

export default {
  data: () => ({ isLoading: false, services: [], newUI: false }),
  mounted () {
    this.fetchServices()
  },
  async created () {
    await this.$store.dispatch('auth/session')
  },
  methods: {
    async fetchServices () {
      this.isLoading = true
      try {
        const { data } = await axios({
          url: `${configurations.WORKER}/query`,
          method: 'POST',
          data: {
            url: btoa('/metadata/configuration')
          }
        })
        this.services = data.eservices
        this.newUI = data.newUI || this.newUI
      } catch (error) {
        this.$store.dispatch('snackbar/setSnackBar', {color: 'error', message: `Failed to load. Please check whether you have internet connection.`, visible: true})
      } finally {
        this.isLoading = false
      }
    },
    routes: function (category) {
      let page
      if (category === 'mptweb') {
        page = configurations.host.mptweb
        if (!window.hasOwnProperty('cordova')) {
          window.location.href = page
          return
        }
        cordova.InAppBrowser.open(page, '_system', 'location=no,enableViewportScale=yes,zoom=no')
      }
      if (category === 'mptgis') {
        page = configurations.host.mptgis
        if (!window.hasOwnProperty('cordova')) {
          window.location.href = page
          return
        }
        cordova.InAppBrowser.open(page, '_system', 'location=no,enableViewportScale=yes,zoom=no')
      }
      if (category === 'mptpay') {
        page = configurations.host.epayment
        if (!window.hasOwnProperty('cordova')) {
          window.location.href = page
          return
        }
        cordova.InAppBrowser.open(page, '_system', 'location=no,enableViewportScale=yes,zoom=no')
      }
      if (category === 'chatbot') {
        page = `https://chatbot.mpt.sabahgov.net`
        if (!window.hasOwnProperty('cordova')) {
          window.location.href = page
          return
        }
        cordova.InAppBrowser.open(page, '_system', 'location=no,enableViewportScale=yes,zoom=no')
      }
    }
  }
}
</script>
